require("typeface-poppins");
require("typeface-hind");
require("./src/styles/global.css");
